import { render, staticRenderFns } from "./my-course-item.vue?vue&type=template&id=3a80ce22&scoped=true"
import script from "./my-course-item.vue?vue&type=script&lang=js"
export * from "./my-course-item.vue?vue&type=script&lang=js"
import style0 from "./my-course-item.vue?vue&type=style&index=0&id=3a80ce22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a80ce22",
  null
  
)

export default component.exports